export const IMPORT_FDDS2_PRODUCT_ID = 'import_fdds2'
export const USE_IS_CONDITIONAL_ORIGINAL_KEY = 'useIsConditionalOriginal'

interface PreparedImportFdds2FormConfig {
  config: Record<string, unknown>
  syntheticUseIsConditionalOriginal: boolean
}

const cloneConfig = (config: Record<string, unknown>): Record<string, unknown> =>
  JSON.parse(JSON.stringify(config))

const normalizeProductId = (productId: string): string => {
  const decoded = decodeURIComponent(String(productId || '')).replace(/___/g, '/')
  const parts = decoded.split('/').filter(Boolean)
  return parts[parts.length - 1] || ''
}

export function prepareImportFdds2FormConfig(
  productId: string,
  accountConfig: Record<string, unknown>
): PreparedImportFdds2FormConfig {
  const config = cloneConfig(accountConfig)
  if (normalizeProductId(productId) !== IMPORT_FDDS2_PRODUCT_ID) {
    return { config, syntheticUseIsConditionalOriginal: false }
  }

  const syntheticUseIsConditionalOriginal = !Object.prototype.hasOwnProperty.call(
    config,
    USE_IS_CONDITIONAL_ORIGINAL_KEY
  )
  if (syntheticUseIsConditionalOriginal) {
    config[USE_IS_CONDITIONAL_ORIGINAL_KEY] = false
  }

  return { config, syntheticUseIsConditionalOriginal }
}

export function prepareImportFdds2ConfigForSave(params: {
  productId: string
  formData: Record<string, unknown>
  originalConfig: Record<string, unknown>
  syntheticUseIsConditionalOriginal: boolean
}): Record<string, unknown> {
  const config = cloneConfig(params.formData)
  if (
    normalizeProductId(params.productId) === IMPORT_FDDS2_PRODUCT_ID &&
    params.syntheticUseIsConditionalOriginal &&
    !Object.prototype.hasOwnProperty.call(
      params.originalConfig,
      USE_IS_CONDITIONAL_ORIGINAL_KEY
    ) &&
    config[USE_IS_CONDITIONAL_ORIGINAL_KEY] === false
  ) {
    delete config[USE_IS_CONDITIONAL_ORIGINAL_KEY]
  }
  return config
}
